import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useRoute } from '../../../hooks';
import { Route } from './Route';
import { useFeatureFlags } from '../../../context';
import { NotFound } from '../../_internal';
const NotFoundRoute = () => React.createElement(Route, { component: NotFound, path: "", mfe: "core" });
/**
 * @deprecated - This should not be used to define routing, please define in the IA Config.
 * {@link https://checkout.atlassian.net/wiki/spaces/HUBV/pages/7053869259/Dashboard+Config+Structure}
 */
export const DynamicRouter = ({ routes, shouldOverrideRoot }) => {
    const { getFeatureFlag } = useFeatureFlags();
    const isFlagEnabled = getFeatureFlag('tempEnableIaNavigation');
    const { canAccessRoute } = useRoute();
    const { path } = useRouteMatch();
    if (!routes) {
        return null;
    }
    const availableRoutes = isFlagEnabled ? routes : routes.filter((route) => canAccessRoute(route));
    const pathAvailable = availableRoutes.some((route) => route.path === path);
    const addOverride = shouldOverrideRoot && !pathAvailable;
    return (React.createElement(Switch, null,
        addOverride && (React.createElement(Route, { component: availableRoutes[0].component, exact: true, path: path, mfe: "core" })),
        availableRoutes.map((routeConfig) => (React.createElement(Route, { key: routeConfig.path, ...routeConfig }))),
        React.createElement(NotFoundRoute, null)));
};
